import { getInstance } from '../index';
import { apiBaseUrl } from '../../utilities/api/apiHelper';

class User {
  constructor() {
    this.axios = getInstance();
  }

  async getUserUXSettings() {
    return await this.axios.get(`${apiBaseUrl}/backendforfrontend/adviser`, {});
  }

  async getUserMarketingAlerts() {
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/marketingupdates`,
      {}
    );
  }
}

const quote = new User(getInstance());
export default quote;
